import styled, { keyframes } from "styled-components";
import { fadeInDown, fadeInLeft } from "react-animations";
import { bodyColor } from "../../../../config/constants";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
// Styles
export const RoutineDiv = styled.div`
  width: 100%;
  display: flex;
  border-radius: 5px;
  @media (max-width: 910px) {
    margin: 0 auto;
    width: 85%;
    max-width: 860px;
    flex-direction: column;
    align-items: flex-end;
    background-color: transparent;
    transition: all 0.5s ease-out;
  }
`;
export const RoutineInfoDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
  display: flex;
`;
export const TitleDiv = styled.div`
  padding: 0 13px;
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 0 0 5px;
  background-color: #f15a24;
  box-shadow: ${({ isHideShadow }) => (isHideShadow ? "0 5px 15px rgb(0 0 0 / 10%)" : "none")};
`;
export const TitleText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;
export const CardDiv = styled.div`
  padding: 5px 0;
  width: 492px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    padding-left: 25px;
    width: 89%;
    height: 40px;
    border-radius: 0 5px 5px 0;
  }
`;
export const InfoHideDiv = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const InfoText = styled.p`
  margin: ${({ margin }) => margin && margin};
  font-size: 14px;
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  color: #000;
`;
export const InfoSpan = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #000;
`;
export const InfoShowDiv = styled.div`
  padding-left: 5px;
  display: flex;
  border-right: ${({ border }) => border && `2px solid ${bodyColor}`};

  @media (max-width: 910px) {
    display: none;
  }
`;
export const InfoShowColumnDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
`;
export const InfoShowDayDiv = styled.div`
  padding: ${({ padding }) => padding && padding};
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
  background-color: ${({ background }) => background && background};
  animation: 0.5s ${fadeInDownAnimation};
  @media (max-width: 910px) {
    height: 20px;
  }
`;
export const InfoTextResponsive = styled.p`
  margin: ${({ margin }) => margin && margin};
  font-size: 14px;
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  color: #000;
  display: none;
  @media (max-width: 910px) {
    display: inline;
  }
`;
export const ShowRoutineButton = styled.button`
  padding: 7px 5px 0;
  width: 35px;
  height: 95%;
  display: flex;
  justify-content: center;
  border: none;
  outline: none;
  background: transparent;
  border-left: ${({ border }) => !border && `2px solid ${bodyColor}`};
  cursor: pointer;
  @media (max-width: 910px) {
    width: auto;
    display: flex;
    border-left: 2px solid #e3e3e3;
  }
`;
export const ArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const RoutineExtraInfoDiv = styled.div`
  margin-top: 2px;
  padding: 5px;
  width: 100%;
  max-width: 300px;
  border-radius: 5px;
  background-color: #fff;
  display: none;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  animation: 0.5s ${fadeInLeftAnimation};
  @media (max-width: 910px) {
    display: flex;
    flex-direction: column;
  }
`;
export const ExtraInfoDayDiv = styled.div`
  padding: ${({ padding }) => padding && padding};
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  background-color: ${({ background }) => background && background};
`;
export const ExtraInfoTitle = styled.p`
  margin: ${({ margin }) => margin && margin};
  font-size: 13px;
  color: #808080;
`;
export const ExtraInfoColumnsDiv = styled.div`
  display: flex;
`;
